export default (state, action) => {
  return Object.assign({}, state, {
    data: {
      ...state.data,
      loading: action.payload,
    },
  });
};
